import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWhatsapp,
  faFacebook,
  faTwitter,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  // 🎨 Styles globaux
  const styles = {
    footer: {
      backgroundColor: "#0A0A0F",
      color: "#ccc",
      paddingTop: "60px",
      paddingBottom: "40px",
      borderTop: "1px solid #222",
      fontFamily: "Poppins, sans-serif",
    },
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 20px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "40px",
      marginBottom: "40px",
    },
    title: {
      color: "#3B82F6",
      textTransform: "uppercase",
      fontWeight: "600",
      fontSize: "16px",
      letterSpacing: "1.5px",
      marginBottom: "16px",
    },
    text: {
      color: "#9CA3AF",
      lineHeight: "1.6",
      marginBottom: "20px",
    },
    link: {
      color: "#9CA3AF",
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      marginBottom: "8px",
      transition: "color 0.2s ease",
    },
    linkHover: {
      color: "#fff",
    },
    iconChevron: {
      color: "#3B82F6",
      marginRight: "8px",
      fontSize: "10px",
    },
    contactItem: {
      display: "flex",
      alignItems: "flex-start",
      color: "#9CA3AF",
      marginBottom: "12px",
    },
    contactIcon: {
      color: "#3B82F6",
      marginRight: "10px",
      marginTop: "3px",
      flexShrink: 0,
    },
    bottom: {
      borderTop: "1px solid #1F2937",
      paddingTop: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
    },
    bottomRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      flexWrap: "wrap",
    },
    social: {
      display: "flex",
      gap: "16px",
    },
    socialIcon: {
      color: "#9CA3AF",
      fontSize: "18px",
      transition: "color 0.2s ease, transform 0.2s ease",
    },
  };

  const quickLinks = [
    { name: "S'inscrire", path: "/demande" },
    { name: "Services", path: "/services" },
    { name: "FAQ", path: "/faq" },
    { name: "À propos", path: "/about" },
    { name: "Témoignages", path: "/testimonials" },
    { name: "Contact", path: "/contact" },
  ];

  const legalLinks = [
    { name: "Mentions légales", path: "/mentions-legales" },
    { name: "Politique de confidentialité", path: "/confidentialite" },
    { name: "Politique des cookies", path: "/cookies" },
    { name: "CGU", path: "/cgu" },
  ];

  const socials = [
    {
      icon: faFacebook,
      url: "https://www.facebook.com/share/19BSqUewPQ/?mibextid=wwXIfr",
    },
    { icon: faTwitter, url: "https://twitter.com/" },
    { icon: faLinkedin, url: "https://linkedin.com/" },
    { icon: faInstagram, url: "https://instagram.com/" },
    { icon: faWhatsapp, url: "https://wa.me/+33774137802" },
  ];

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.grid}>
          {/* À propos */}
          <div>
            <h3 style={styles.title}>À propos</h3>
            <p style={styles.text}>
              <strong style={{ color: "#fff" }}>AidFoundation</strong> — Votre
              solution de confiance pour une gestion financière simple, rapide
              et 100 % digitale.
            </p>
            <a
              href="https://unpaidfinancial.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#3B82F6",
                textDecoration: "none",
                fontWeight: 500,
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              En savoir plus
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                style={{ width: "14px", height: "14px", marginLeft: "6px" }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </a>
          </div>

          {/* Liens rapides */}
          <div>
            <h3 style={styles.title}>Liens rapides</h3>
            {quickLinks.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                style={styles.link}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = styles.linkHover.color)
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "#9CA3AF")}
              >
                <FontAwesomeIcon icon={faChevronRight} style={styles.iconChevron} />
                {item.name}
              </Link>
            ))}
          </div>

          {/* Légaux */}
          <div>
            <h3 style={styles.title}>Légaux</h3>
            {legalLinks.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                style={styles.link}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = styles.linkHover.color)
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "#9CA3AF")}
              >
                <FontAwesomeIcon icon={faChevronRight} style={styles.iconChevron} />
                {item.name}
              </Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h3 style={styles.title}>Contact</h3>
            <div style={styles.contactItem}>
              <FontAwesomeIcon icon={faMapMarkerAlt} style={styles.contactIcon} />
              <span>
                123 Rue de la Finance
                <br />
                75001 Paris, France
              </span>
            </div>
            <div style={styles.contactItem}>
              <FontAwesomeIcon icon={faEnvelope} style={styles.contactIcon} />
              <a
                href="mailto:contact@aidfoundation.eu"
                style={{ color: "#9CA3AF", textDecoration: "none" }}
              >
                contact@aidfoundation.eu
              </a>
            </div>
            <div style={styles.contactItem}>
              <FontAwesomeIcon icon={faPhone} style={styles.contactIcon} />
              <a
                href="tel:+33774137802"
                style={{ color: "#9CA3AF", textDecoration: "none" }}
              >
                +33 7 74 13 78 02
              </a>
            </div>
          </div>
        </div>

        {/* Bas de page */}
        <div style={styles.bottom}>
          <div style={styles.bottomRow}>
            <p style={{ color: "#6B7280", fontSize: "14px" }}>
              © {currentYear}{" "}
              <span style={{ color: "#fff", fontWeight: "600" }}>
                AidFoundation
              </span>
              . Tous droits réservés.
            </p>
            <div style={styles.social}>
              {socials.map((s, i) => (
                <a
                  key={i}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.socialIcon}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#3B82F6";
                    e.currentTarget.style.transform = "scale(1.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#9CA3AF";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <FontAwesomeIcon icon={s.icon} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
